var Backbone = require('backbone');
var _ = require('underscore');

require('./CreateAccount.less');


module.exports = Backbone.View.extend({

    el: '.CreateAccount',

    events: {
        'click input': 'resetErrorState',
        'change input': 'resetErrorState',
        'focus  input': 'resetErrorState',
        'input input': 'resetErrorState',

        'click .CreateAccount-buttonCreate': 'onCreateClick'
    },


    initialize: function () {
    },


    resetErrorState: function (e) {
        $(e.currentTarget)
            .closest('.CreateAccount-inputLine')
            .removeClass('CreateAccount-inputLine--error CreateAccount-inputLine--error-with-input');
    },


    show: function () {
        this.$el.addClass('visible');
    },


    hide: function () {
        this.$el.removeClass('visible');
    },


    checkRequired: function (params) {
        var hasError = false;
        var self = this;

        //check form inputs
        this.$('.CreateAccount-inputName').each(function (ind, item) {
            if (hasError) return;

            var $wrapper = $(item).closest('.CreateAccount-inputLine');
            var $input = $('input', $wrapper).eq(0);
            var inputName = $input.attr('name');
            var inputType = $input.attr('type');
            var val = $.trim($input.val());

            if (!val) {
                params.focusOnError && $input.focus();
                $wrapper.addClass('CreateAccount-inputLine--error-with-input');
                hasError = true;

                return;
            }
        });

        if (this.$('input[name="password"]').val() != this.$('input[name="confirm"]').val()) {
            params.focusOnError && this.$('input[name="confirm"]').focus();
            this.$('input[name="confirm"]')
                .closest('.CreateAccount-inputLine')
                .addClass('CreateAccount-inputLine--error-with-input');
            hasError = true;

            return;
        }

        return !hasError;
    },


    getFormData: function () {
        var data = {
            'firstname':  this.$('input[name="firstname"]').val(),
            'lastname':  this.$('input[name="lastname"]').val(),
            'company':  this.$('input[name="company"]').val(),
            'phone': this.$('input[name="phone"]').val(),
            'email':  this.$('input[name="email"]').val(),
            'password':  this.$('input[name="password"]').val(),
            'hash':  this.$('input[name="hash"]').val()
        };

        return data;
    },


    onCreateClick: function () {
        if (!this.checkRequired({focusOnError: true})) return;

        var data = this.getFormData();
        var email = data.email;

        var $button = this.$('.CreateAccount-buttonCreate');

        $button.addClass('Button--loading');

        this._xhr && this._xhr.abort();

        this._xhr = $.ajax(Urls['submissions:api:create']('json'), {
            method: 'POST',
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            data: JSON.stringify({
                'firstName': data.firstname,
                'lastName': data.lastname,
                'company': data.company,
                'phone': data.phone,
                'email': data.email,
                'password': data.password,
                'hash': data.hash //filled only for invited user (with prepopulated email)
            }),
            success: function (data) {
                //store last used email
                this.trigger('login-email', email);

                $button.removeClass('Button--loading');

                Backbone.history.navigate(Urls['submissions:login'](), {trigger: 'true'});
            }.bind(this),
            error: function (e, tp) {
                $button.removeClass('Button--loading');

                if (tp != 'abort') {
                    if (e.status == 400) { //bad request
                        alert('Error: ' + e.responseText);
                    } else {
                        alert('Error ' + e.status + ': ' + e.statusText);
                    }
                }

                console.log('error', arguments);
            }.bind(this)
        });
    }


});



//////////////////
// WEBPACK FOOTER
// ./assets/app/submissions/components/CreateAccount/CreateAccount.js
// module id = 104
// module chunks = 0